(function () {
  'use strict';

  var STORAGE_KEY = 'demob_popup';
  var TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 days
  var DELAY_MS = 10000;                   // 10 seconds

  var overlay  = document.getElementById('demob-popup');
  var mainDiv  = document.getElementById('demob-popup-main');
  var successDiv = document.getElementById('demob-popup-success');
  var closeBtn = document.getElementById('demob-popup-close');
  var declineBtn = document.getElementById('demob-popup-decline');
  var form     = document.getElementById('demob-popup-form');

  if (!overlay) return;

  /* ── localStorage helpers ─────────────────────────────────────── */
  function isDismissed() {
    try {
      var val = localStorage.getItem(STORAGE_KEY);
      if (!val) return false;
      return (Date.now() - parseInt(val, 10)) < TTL_MS;
    } catch (e) {
      return false;
    }
  }

  function saveDismissal() {
    try {
      localStorage.setItem(STORAGE_KEY, String(Date.now()));
    } catch (e) {}
  }

  /* ── Show / hide ──────────────────────────────────────────────── */
  function showPopup() {
    overlay.setAttribute('aria-hidden', 'false');
    var emailInput = document.getElementById('demob-popup-email');
    if (emailInput) emailInput.focus();
  }

  function hidePopup() {
    overlay.setAttribute('aria-hidden', 'true');
  }

  function dismiss() {
    saveDismissal();
    hidePopup();
  }

  /* ── Success state ────────────────────────────────────────────── */
  function showSuccess() {
    if (mainDiv) mainDiv.style.display = 'none';
    if (declineBtn) declineBtn.style.display = 'none';
    if (successDiv) successDiv.style.display = '';
    saveDismissal();
    // Auto-close after 3 seconds
    setTimeout(hidePopup, 3000);
  }

  /* ── Event listeners ──────────────────────────────────────────── */
  if (closeBtn) closeBtn.addEventListener('click', dismiss);
  if (declineBtn) declineBtn.addEventListener('click', dismiss);

  // Click on the dark overlay (not the popup box) closes it
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) dismiss();
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') {
      dismiss();
    }
  });

  /* ── AJAX form submit ─────────────────────────────────────────── */
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      var submitBtn = form.querySelector('.demob-popup__submit');
      if (submitBtn) submitBtn.disabled = true;

      var formData = new FormData(form);

      fetch('/contact', {
        method: 'POST',
        body: formData,
        headers: { 'Accept': 'application/json' }
      })
      .then(function (response) {
        // 200 = success, 422 = already subscribed (treat as success)
        // redirected = Shopify redirected after success
        if (response.ok || response.redirected || response.status === 422) {
          showSuccess();
        } else {
          // Unexpected server error — fall back to standard form submit
          form.submit();
        }
      })
      .catch(function () {
        // Network error — fall back to standard form submit
        form.submit();
      });
    });
  }

  /* ── Schedule popup after delay ───────────────────────────────── */
  if (!isDismissed()) {
    setTimeout(showPopup, DELAY_MS);
  }

}());
